<template>
    <CRow>
        <CCol col="12">
            <CAlert :color="messageColor" closeButton :show.sync="dismissCountDown" fade >{{ err_msg }} </CAlert>
            <CCard>
				<CCardHeader>
					<div class="row">
						<CCol sm="6" class="align-self-center">
							<strong>Payment Calculator Settings</strong>
						</CCol>
						<CCol sm="6" class="align-self-center">
							<div class="text-sm-right mt-3 mt-sm-0">
							</div>
						</CCol>
					</div>
				</CCardHeader>
				<CCardBody>
                    <v-server-table
                        :key="tableKey"
                        :url="module.api.list"
                        :columns="columns"
                        :options="options"
                        ref="myTable"
                        :data="data"
                        @loaded="onDataLoaded">
                            <template #actions="data">
                                <CButton
                                    color="success"
                                    v-c-tooltip="$lang.buttons.general.crud.edit"
                                    v-on:click="editTableRow(data.row.id)"
                                    v-if="checkPermission('edit-payment-calculator')"
                                >
                                    <i class="fas fa-pencil-alt"></i>
                                </CButton>
                            </template>
                    </v-server-table>
				</CCardBody>
			</CCard>
        </CCol>
    </CRow>
</template>

<script>
import Vue from "vue";
import VueForm from "vue-form";
import { paymentCalculator } from "/src/store/url.js";
import { Mixin } from "/src/mixins/index.js";
import options from "/src/validations/validations.js";
import { ServerTable } from "vue-tables-2";
import VueSweetalert2 from "vue-sweetalert2";
import VueJsonToCsv from "vue-json-to-csv";
import store from "@/store/store";
import required_span from "../../components/layouts/general/required-span";
import {required} from "vuelidate/lib/validators";

Vue.use(VueSweetalert2);
Vue.use(ServerTable, {}, false);
Vue.use(VueForm, options);

export default {
    name: "PaymentCalculator",
    mixins: [Mixin],
    components: {
        VueJsonToCsv,
        required_span,
    },
    data() {
        return {
            messageColor: "success",
            messageColorModal: "danger",
            err_msg: "",
            alertMessage: "",
            showAlert: false,
            dismissCountDownModal: 0,
            dismissCountDown: 0,
            dismissCountDownS: 0,
            self: this,
            activePage: 1,
            module: paymentCalculator,
            json_data: [],
            json_label: {},
            json_title: "",
            tableKey: 0, // Add a key to force table reload
            data: [],
            submitted: false,
            paymentCalculatorUpdate: {
                id: ""
            },
            columns: [
                this.$lang.paymentCalculator.table.columns.title,
                this.$lang.paymentCalculator.table.columns.isGstServiceProviderString,
                this.$lang.paymentCalculator.table.columns.isGstEndUserString,
                this.$lang.paymentCalculator.table.columns.actions,
            ],
            options: {
                headings: {
                    title: this.$lang.paymentCalculator.table.title,
                    isGstServiceProviderString: this.$lang.paymentCalculator.table.isGstServiceProviderString,
                    isGstEndUserString: this.$lang.paymentCalculator.table.isGstEndUserString,
                    actions: this.$lang.paymentCalculator.table.actions,
                },
                sortable: [this.$lang.paymentCalculator.table.createdAt],
                filterable: [this.$lang.paymentCalculator.table.createdAt],
                perPage:50,
            },
        };
    },
    created() {
        let self = this;
        console.log("getItem:",localStorage.getItem("notificationMessage"));
        if (localStorage.getItem("notificationMessage") !== "") {
            self.dismissCountDown = 10;
            self.alertMessage = localStorage.getItem("notificationMessage");
            self.messageColor = localStorage.getItem("notificationType");
            localStorage.setItem("notificationMessage", "");
            localStorage.setItem("notificationType", "");
        }
    },
    mounted() {
        let self = this;
        store.commit("showLoader", false);
        self.dismissCountDown = 0;
        self.dismissCountDownS = 0;
        if (localStorage.getItem("showAlert") !== "") {
            this.setAlert(true);
        }
        this.setAlert(false);
        localStorage.setItem("showAlert", "");
    },
    watch: {
        $route: {
            immediate: true,
            handler(route) {
                if (route.query && route.query.page) {
                    this.activePage = Number(route.query.page);
                }
            },
        },
    },
    methods: {
        setAlert(value) {
            this.showAlert = value;
        },
        pageChange(val) {
            this.$router.push({ query: { page: val } });
        },
        onDataLoaded(data) {
            // console.log("data.data.data",data.data.data);
        },
        editTableRow(item) {
            this.$router.push({path: `payment-calculator/edit/${item}`});
        }
    },
};
</script>
